import React from "react";

const Management = () => {
  return (
    <section className="management-area pt-100 pb-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-content text-center">
              <h1 className="fs-50 pb-2 fw-bold">
                Une méthode d'audit exhaustive, de la donnée brute au recouvrement
              </h1>
              <p className="fs-18">
                Depuis 2019, WBC accompagne des environnements exigeants : retail, distribution, industrie, multi-entités et volumes documentaires importants. L'objectif n'est pas seulement d'identifier une anomalie, mais de produire une preuve exploitable et un plan de récupération.
              </p>
            </div>
            <div className="management-content pt-60">
              {managementData.map((item) => (
                <div className="management-item" key={item.id}>
                  <div className="number">{item.id}</div>
                  <div className="text">
                    <div className="fs-20 fw-bold">{item.title}</div>
                    <div className="fs-18">{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const managementData = [
  {
    id: 1,
    title: "Cadrage de la mission",
    desc: "Définition du périmètre : entités, fournisseurs, années, contrats, FEC, commandes, réceptions, factures, baux commerciaux et emails utiles.",
  },
  {
    id: 2,
    title: "Collecte et normalisation",
    desc: "Structuration des fichiers hétérogènes : PDF, Excel, exports ERP, FEC, master files, conditions tarifaires, annexes et conventions.",
  },
  {
    id: 3,
    title: "Rapprochements automatiques",
    desc: "Comparaison des montants facturés avec les prix attendus, remises, escomptes, ristournes, avoirs, doubles paiements et clauses applicables.",
  },
  {
    id: 4,
    title: "Qualification des écarts",
    desc: "Classement des anomalies par montant, probabilité de récupération, preuve disponible, fournisseur, période et action de validation requise.",
  },
  {
    id: 5,
    title: "Dossier de preuve",
    desc: "Préparation des tableaux, synthèses, extraits sources et arguments contractuels utilisables par la DAF, les achats ou le fournisseur.",
  },
  {
    id: 6,
    title: "Recouvrement et sécurisation",
    desc: "Accompagnement des relances, négociations, avoirs et actions correctives pour éviter que la marge récupérée ne se reperde l'année suivante.",
  },
];

export default Management;
